import { PageShell } from '@/components/layout/page-shell';

export function CreatorProfileSkeleton() {
  return (
    <div className="min-h-dvh bg-black">
      {/* Banner skeleton — 180px */}
      <div className="h-[180px] w-full bg-white/5 animate-pulse" />

      {/* Avatar skeleton */}
      <PageShell spacing="none" className="-mt-14">
        <div className="h-[112px] w-[112px] rounded-full bg-white/10 border-[3px] border-black animate-pulse shrink-0" />
      </PageShell>

      {/* Info skeleton */}
      <PageShell spacing="none" className="mt-3 space-y-3">
        {/* Name + buttons */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="h-7 w-48 bg-white/10 rounded animate-pulse" />
            <div className="h-5 w-5 rounded-full bg-white/10 animate-pulse" />
          </div>
          <div className="flex gap-2">
            <div className="h-8 w-24 bg-white/10 rounded animate-pulse" />
          </div>
        </div>
        {/* Handler + stats */}
        <div className="flex items-center gap-3">
          <div className="h-4 w-24 bg-white/10 rounded animate-pulse" />
          <div className="h-4 w-32 bg-white/10 rounded animate-pulse" />
          <div className="h-4 w-28 bg-white/10 rounded animate-pulse" />
        </div>
        {/* Bio */}
        <div className="max-w-2xl space-y-2">
          <div className="h-4 w-full bg-white/5 rounded animate-pulse" />
          <div className="h-4 w-3/4 bg-white/5 rounded animate-pulse" />
        </div>
        {/* Social */}
        <div className="flex gap-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="h-8 w-8 bg-white/5 rounded animate-pulse" />
          ))}
        </div>
      </PageShell>

      {/* Tabs skeleton */}
      <div className="mt-6 border-b border-white/10">
        <PageShell spacing="none" className="flex gap-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="h-10 w-16 bg-white/5 rounded animate-pulse" />
          ))}
        </PageShell>
      </div>

      {/* Content grid skeleton */}
      <PageShell>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3.5">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="animate-pulse">
              <div className="aspect-video bg-white/5 rounded" />
              <div className="h-4 bg-white/5 rounded mt-2 w-3/4" />
              <div className="h-3 bg-white/5 rounded mt-1 w-1/2" />
            </div>
          ))}
        </div>
      </PageShell>
    </div>
  );
}
